import React, { useState } from 'react';
import './Scanner.css';

const fN = (n, d=2) => n != null && !isNaN(n) ? Number(n).toFixed(d) : '--';

const SCAN_DATA = [
  { sym:'BBBY', name:'Bed Bath & Beyond', price:0.72,  chg:44.1,  vol:'892M', float:'28M',   fsz:'low', rs:97, alert:'hot',  sector:'Retail',      mktcap:'$62M',   vwap:0.66,  gap:'+38%', halt:true  },
  { sym:'GME',  name:'GameStop Corp',     price:14.72, chg:18.4,  vol:'184M', float:'231M',  fsz:'mid', rs:91, alert:'hot',  sector:'Gaming',      mktcap:'$4.9B',  vwap:13.88, gap:'+12%', halt:false },
  { sym:'AMC',  name:'AMC Entertainment', price:3.88,  chg:11.2,  vol:'312M', float:'289M',  fsz:'mid', rs:88, alert:'hot',  sector:'Media',       mktcap:'$1.5B',  vwap:3.61,  gap:'+8%',  halt:false },
  { sym:'MARA', name:'Marathon Digital',  price:22.14, chg:6.7,   vol:'87M',  float:'168M',  fsz:'mid', rs:74, alert:'warm', sector:'Crypto',      mktcap:'$4.2B',  vwap:21.44, gap:'+4%',  halt:false },
  { sym:'RIOT', name:'Riot Platforms',    price:11.82, chg:5.2,   vol:'62M',  float:'244M',  fsz:'mid', rs:71, alert:'warm', sector:'Crypto',      mktcap:'$2.8B',  vwap:11.44, gap:'+3%',  halt:false },
  { sym:'NVDA', name:'Nvidia Corp',       price:487.22,chg:3.81,  vol:'41.7M',float:'2.46B', fsz:'hi',  rs:68, alert:'warm', sector:'Technology',  mktcap:'$1.2T',  vwap:484.11,gap:'+2%',  halt:false },
  { sym:'SOFI', name:'SoFi Technologies', price:8.44,  chg:3.1,   vol:'44M',  float:'892M',  fsz:'hi',  rs:61, alert:'warm', sector:'Fintech',     mktcap:'$8.1B',  vwap:8.22,  gap:'+2%',  halt:false },
  { sym:'AMD',  name:'Advanced Micro',    price:164.33,chg:0.92,  vol:'38.4M',float:'1.61B', fsz:'hi',  rs:52, alert:'cool', sector:'Technology',  mktcap:'$267B',  vwap:163.77,gap:'+1%',  halt:false },
  { sym:'AAPL', name:'Apple Inc',         price:187.42,chg:1.23,  vol:'48.2M',float:'15.4B', fsz:'hi',  rs:49, alert:'cool', sector:'Technology',  mktcap:'$2.91T', vwap:186.88,gap:'0%',   halt:false },
  { sym:'TSLA', name:'Tesla Inc',         price:174.91,chg:-2.14, vol:'92.1M',float:'3.17B', fsz:'hi',  rs:38, alert:'cool', sector:'Automotive',  mktcap:'$556B',  vwap:177.22,gap:'-1%',  halt:false },
  { sym:'MULN', name:'Mullen Automotive', price:0.18,  chg:32.1,  vol:'1.2B', float:'14M',   fsz:'low', rs:94, alert:'hot',  sector:'Automotive',  mktcap:'$28M',   vwap:0.15,  gap:'+28%', halt:true  },
  { sym:'CLOV', name:'Clover Health',     price:1.44,  chg:22.8,  vol:'287M', float:'198M',  fsz:'mid', rs:86, alert:'hot',  sector:'Healthcare',  mktcap:'$384M',  vwap:1.28,  gap:'+18%', halt:false },
];

const FILTERS = {
  float: ['All Floats','Low Float (<50M)','Mid Float (50M-500M)','Large Float (>500M)'],
  change: ['All % Change','>5%','>10%','>20%','>30%'],
  volume: ['All Volume','>10M','>50M','>100M','>500M'],
  sector: ['All Sectors','Technology','Gaming','Crypto','Retail','Media','Fintech','Healthcare','Automotive'],
  alert: ['All Alerts','🔥 Hot','⚠️ Warm','✅ Cool'],
};

export default function Scanner() {
  const [search, setSearch] = useState('');
  const [filterFloat, setFilterFloat] = useState('All Floats');
  const [filterChg, setFilterChg] = useState('All % Change');
  const [filterVol, setFilterVol] = useState('All Volume');
  const [filterSector, setFilterSector] = useState('All Sectors');
  const [filterAlert, setFilterAlert] = useState('All Alerts');
  const [sortBy, setSortBy] = useState('rs');
  const [sortDir, setSortDir] = useState('desc');
  const [selected, setSelected] = useState(null);

  function handleSort(col) {
    if(sortBy === col) setSortDir(d => d==='asc'?'desc':'asc');
    else { setSortBy(col); setSortDir('desc'); }
  }

  function parseVol(v) {
    if(!v) return 0;
    if(v.includes('B')) return parseFloat(v)*1e9;
    if(v.includes('M')) return parseFloat(v)*1e6;
    if(v.includes('K')) return parseFloat(v)*1e3;
    return parseFloat(v);
  }

  const filtered = SCAN_DATA.filter(s => {
    if(search && !s.sym.includes(search.toUpperCase()) && !s.name.toUpperCase().includes(search.toUpperCase())) return false;
    if(filterFloat !== 'All Floats') {
      if(filterFloat === 'Low Float (<50M)'       && s.fsz !== 'low') return false;
      if(filterFloat === 'Mid Float (50M-500M)'   && s.fsz !== 'mid') return false;
      if(filterFloat === 'Large Float (>500M)'    && s.fsz !== 'hi')  return false;
    }
    if(filterChg !== 'All % Change') {
      const min = parseFloat(filterChg.replace('>','').replace('%',''));
      if(s.chg < min) return false;
    }
    if(filterVol !== 'All Volume') {
      const min = parseFloat(filterVol.replace('>','').replace('M',''))*1e6;
      if(parseVol(s.vol) < min) return false;
    }
    if(filterSector !== 'All Sectors' && s.sector !== filterSector) return false;
    if(filterAlert !== 'All Alerts') {
      if(filterAlert === '🔥 Hot'  && s.alert !== 'hot')  return false;
      if(filterAlert === '⚠️ Warm' && s.alert !== 'warm') return false;
      if(filterAlert === '✅ Cool'  && s.alert !== 'cool') return false;
    }
    return true;
  }).sort((a,b) => {
    let av = a[sortBy], bv = b[sortBy];
    if(sortBy === 'vol') { av = parseVol(a.vol); bv = parseVol(b.vol); }
    if(sortDir === 'asc') return av > bv ? 1 : -1;
    return av < bv ? 1 : -1;
  });

  const hotCount  = SCAN_DATA.filter(s=>s.alert==='hot').length;
  const haltCount = SCAN_DATA.filter(s=>s.halt).length;
  const topMover  = [...SCAN_DATA].sort((a,b)=>b.chg-a.chg)[0];

  function alertIcon(a) {
    if(a==='hot')  return '🔥';
    if(a==='warm') return '⚠️';
    return '✅';
  }

  function fszClass(f) {
    if(f==='low') return 'fl-low';
    if(f==='mid') return 'fl-mid';
    return 'fl-hi';
  }
  function fszLabel(f) {
    if(f==='low') return 'Low Float';
    if(f==='mid') return 'Mid Float';
    return 'Large';
  }

  return (
    <div className="sc-page">
      {/* HEADER */}
      <div className="sc-header">
        <div className="sc-header-left">
          <div className="sc-title">Small Cap Momentum Scanner</div>
          <div className="sc-subtitle">Real-time momentum alerts · Float-aware · RS scoring</div>
        </div>
        <div className="sc-header-stats">
          <div className="sc-hstat hot">
            <span>🔥</span>
            <div><div className="sc-hstat-val">{hotCount}</div><div className="sc-hstat-label">Hot Plays</div></div>
          </div>
          <div className="sc-hstat halt">
            <span>⛔</span>
            <div><div className="sc-hstat-val">{haltCount}</div><div className="sc-hstat-label">Halted</div></div>
          </div>
          <div className="sc-hstat top">
            <span>📈</span>
            <div><div className="sc-hstat-val">{topMover.sym} +{fN(topMover.chg)}%</div><div className="sc-hstat-label">Top Mover</div></div>
          </div>
        </div>
      </div>

      {/* FILTERS */}
      <div className="sc-filters">
        <input
          className="sc-search"
          placeholder="Search symbol or name..."
          value={search}
          onChange={e=>setSearch(e.target.value)}
        />
        {Object.entries(FILTERS).map(([key, opts]) => (
          <select
            key={key}
            className="sc-filter-sel"
            value={key==='float'?filterFloat:key==='change'?filterChg:key==='volume'?filterVol:key==='sector'?filterSector:filterAlert}
            onChange={e => {
              if(key==='float')  setFilterFloat(e.target.value);
              if(key==='change') setFilterChg(e.target.value);
              if(key==='volume') setFilterVol(e.target.value);
              if(key==='sector') setFilterSector(e.target.value);
              if(key==='alert')  setFilterAlert(e.target.value);
            }}
          >
            {opts.map(o=><option key={o}>{o}</option>)}
          </select>
        ))}
        <button className="sc-reset" onClick={()=>{setSearch('');setFilterFloat('All Floats');setFilterChg('All % Change');setFilterVol('All Volume');setFilterSector('All Sectors');setFilterAlert('All Alerts');}}>
          Reset
        </button>
        <span className="sc-count">{filtered.length} results</span>
      </div>

      {/* TABLE */}
      <div className="sc-table-wrap">
        <table className="sc-table">
          <thead>
            <tr>
              <th style={{textAlign:'left'}} onClick={()=>handleSort('sym')}>Symbol {sortBy==='sym'?(sortDir==='desc'?'↓':'↑'):''}</th>
              <th style={{textAlign:'left'}}>Name</th>
              <th onClick={()=>handleSort('alert')}>Alert</th>
              <th onClick={()=>handleSort('price')}>Price {sortBy==='price'?(sortDir==='desc'?'↓':'↑'):''}</th>
              <th onClick={()=>handleSort('chg')}>Chg% {sortBy==='chg'?(sortDir==='desc'?'↓':'↑'):''}</th>
              <th onClick={()=>handleSort('vol')}>Volume {sortBy==='vol'?(sortBy==='vol'?sortDir==='desc'?'↓':'↑':''):''}</th>
              <th>Float</th>
              <th>Gap</th>
              <th>VWAP</th>
              <th>Sector</th>
              <th onClick={()=>handleSort('rs')}>RS {sortBy==='rs'?(sortDir==='desc'?'↓':'↑'):''}</th>
              <th>Halt</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(s => (
              <tr
                key={s.sym}
                className={`sc-row ${selected===s.sym?'selected':''} ${s.alert==='hot'?'row-hot':''}`}
                onClick={()=>setSelected(s.sym===selected?null:s.sym)}
              >
                <td>
                  <div className="sc-sym-cell">
                    <div className="sc-sym-label">{s.sym}</div>
                    {s.alert==='hot' && <span style={{fontSize:12}}>🔥</span>}
                    {s.halt && <span className="sc-halt-badge">HALT</span>}
                  </div>
                </td>
                <td><div className="sc-name">{s.name}</div></td>
                <td style={{textAlign:'center'}}>{alertIcon(s.alert)}</td>
                <td><b>${fN(s.price)}</b></td>
                <td><span className={`sc-chg ${s.chg>=0?'pos':'neg'}`}>{s.chg>=0?'+':''}{fN(s.chg)}%</span></td>
                <td style={{color:'#60a5fa'}}>{s.vol}</td>
                <td><span className={`float-badge-sc ${fszClass(s.fsz)}`}>{s.float} · {fszLabel(s.fsz)}</span></td>
                <td style={{color:s.gap.startsWith('+')?'#22c55e':s.gap==='0%'?'#484f58':'#ef4444'}}>{s.gap}</td>
                <td style={{color:'#a78bfa'}}>${fN(s.vwap)}</td>
                <td style={{color:'#484f58',fontSize:10}}>{s.sector}</td>
                <td>
                  <div className="sc-rs-wrap">
                    <div className="sc-rs-bar"><div className="sc-rs-fill" style={{width:s.rs+'%',background:s.rs>80?'#ef4444':s.rs>60?'#f59e0b':'#22c55e'}}></div></div>
                    <span className="sc-rs-val" style={{color:s.rs>80?'#ef4444':s.rs>60?'#f59e0b':'#22c55e'}}>{s.rs}</span>
                  </div>
                </td>
                <td style={{textAlign:'center'}}>{s.halt?<span className="sc-halt-dot">⛔</span>:<span style={{color:'#484f58',fontSize:10}}>—</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* DETAIL PANEL */}
      {selected && (() => {
        const s = SCAN_DATA.find(x=>x.sym===selected);
        if(!s) return null;
        const isUp = s.chg >= 0;
        return (
          <div className="sc-detail">
            <div className="sc-detail-header">
              <div>
                <div className="sc-detail-sym">{s.sym} {alertIcon(s.alert)}</div>
                <div className="sc-detail-name">{s.name}</div>
              </div>
              <div className="sc-detail-price" style={{color:isUp?'#22c55e':'#ef4444'}}>
                ${fN(s.price)}
                <span style={{fontSize:12,marginLeft:8}}>{isUp?'+':''}{fN(s.chg)}%</span>
              </div>
              <button className="sc-detail-close" onClick={()=>setSelected(null)}>✕</button>
            </div>
            <div className="sc-detail-grid">
              {[
                ['Float',`${s.float} · ${fszLabel(s.fsz)}`],
                ['Market Cap',s.mktcap],
                ['Volume',s.vol],
                ['VWAP',`$${fN(s.vwap)}`],
                ['Gap',s.gap],
                ['RS Score',s.rs+'/100'],
                ['Sector',s.sector],
                ['Halt Status',s.halt?'⛔ Currently Halted':'✅ Trading'],
              ].map(([l,v])=>(
                <div key={l} className="sc-detail-item">
                  <div className="sc-detail-label">{l}</div>
                  <div className="sc-detail-val">{v}</div>
                </div>
              ))}
            </div>
          </div>
        );
      })()}
    </div>
  );
}